module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-4.b0a4c98a.mp3";